import { render } from "./CallReasonsReport.vue?vue&type=template&id=3d6bd96e&scoped=true"
import script from "./CallReasonsReport.vue?vue&type=script&lang=js"
export * from "./CallReasonsReport.vue?vue&type=script&lang=js"

import "./CallReasonsReport.vue?vue&type=style&index=0&id=3d6bd96e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6bd96e"]])

export default __exports__